import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-right, margin, padding"><path d="M13.25 3C15.3211 3 17 4.67893 17 6.75V17.25C17 19.3211 15.3211 21 13.25 21H6.75C4.67893 21 3 19.3211 3 17.25V6.75C3 4.67893 4.67893 3 6.75 3H13.25Z" fill="currentColor"/><path d="M20.25 3C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21C19.8358 21 19.5 20.6642 19.5 20.25V3.75C19.5 3.33579 19.8358 3 20.25 3Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutRight;
